@let optionValue = option();

<div class="filter-option">
  <div class="filter-option__label">
    @if (optionValue.iconOrAvatar) {
      @if (isOptionIconType(optionValue.iconOrAvatar)) {
        <palantir-icon
          [name]="optionValue.iconOrAvatar.icon"
          [style]="{ color: optionValue.iconOrAvatar.color }"
        />
      } @else if (isOptionAvatarType(optionValue.iconOrAvatar)) {
        <palantir-avatar size="5xs" [fallbackText]="optionValue.label">
          <img [src]="optionValue.iconOrAvatar.avatar" alt="avatar" />
        </palantir-avatar>
      }
    }
    <palantir-text size="base" [attr.type]="textType()">
      {{ optionValue.label }}
    </palantir-text>
  </div>
  @if (optionValue.description) {
    <div
      class="filter-option__description"
      [style]="{
        '--line-clamp': option().maxLines ?? 3,
      }"
    >
      <palantir-text size="base" type="description">
        {{ optionValue.description }}
      </palantir-text>
    </div>
  }
</div>
